/**
 * Created by fers on 26.09.15.
 */

import { declareEntity } from '../fw/MetaDataHelper.ts';
import { v4 as uuidv4 } from 'uuid';
import {INVOCATION_PRIORITY_NORMAL, INVOCATION_PRIORITY} from './FlowInvocationType';

export const STATUS_WAITING = "waiting";
export const STATUS_IN_PROGRESS = "in-progress";
export const STATUS_FINISHED = "finished";
export const STATUS_FAILED = "failed";
export const STATUS_SKIPPED = "skipped";

export const StatusType = {
    [STATUS_WAITING]: {
        name: "Waiting",
        color: '#aaaaaa',
    },
    [STATUS_IN_PROGRESS]: {
        name: "In Progress",
        color: '#158fef',
    },
    [STATUS_FINISHED]: {
        name: "Finished",
        color: '#228b22',
    },
    [STATUS_FAILED]: {
        name: "Failed",
        color: '#ff0000',
    },
    [STATUS_SKIPPED]: {
        name: "Skipped",
        color: '#666666',
    },
};


export default declareEntity({
    entity: 'jobs',
    graphQL: "Job",
    name: "Jobs",
    dynamoPrefix: 'sys',
    storageType: 'central',
    userEditable: false,
    defaultOrder: ['id'],
    fields: (types) => { return {
        id: {
            name: "Job ID",
            type: "id",
            primaryKey: true,
            defaultValue: () => {
                return uuidv4();
            },
        },
        organisation: {
            name: "Organisation",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (parent) => {
                if (parent) {
                    return parent['organisation_id'];
                }
            },
            userEditable: false,
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            hiddenCreate: true,
            userEditable: false,
            defaultValue: (parent) => {
                if (parent) {
                    return parent['instance_id'];
                }
            },
        },
        priority: {
            name: "Priority",
            type: "enum",
            defaultValue: INVOCATION_PRIORITY_NORMAL,
            values: INVOCATION_PRIORITY,
        },
        channel: {
            name: "Application",
            type: "relation",
            to: () => types['channels'],
            userEditable: false,
            defaultValue: (parent) => {
                if (parent) {
                    return parent['channel_id'];
                }
            },
        },
        organisation_channel: {
            name: "Organisation+Channel",
            type: "string",
            userEditable: false,
            defaultValue: (parent) => {
                if (parent) {
                    return parent['organisation_id'] + "|" + parent['channel_id'];
                }
            },
        },
        timeout: {
            name: "Timeout",
            type: "int",
        },
        type: {
            name: "Type",
            type: "enum",
            values: {
                "transformer": {
                    name: "Transforming data"
                },
                "fetcher": {
                    name: "Fetching and Transforming data"
                },
                "initial-fetcher": {
                    name: "Initial Fetching of data"
                },
                "gen-actions": {
                    name: "Generate actions"
                },
                "gen-scenarios": {
                    name: "Generate scenarios"
                },
            }
        },
        name: {
            name: "Name",
            type: "string",
            defaultValue: null,
        },
        args: {
            name: "Arguments",
            type: "object",
            defaultValue: null,
        },
        message: {
            name: "Message",
            type: "string",
            defaultValue: null,
        },
        expiresIn: {
            name: "Expires in",
            description: "We need to delete jobs after some time",
            type: "int",
            userEditable: false,
            export: false,
            import: false,
            defaultValue: () => {
                /* expire after 45 days */
                return Math.floor(Date.now() / 1000) + 45 * 24 * 60 * 60;
            },
        },
        status: {
            name: "Status",
            type: "enum",
            defaultValue: STATUS_WAITING,
            values: StatusType
        },
        errorStack: {
            name: "Error stack",
            type: "text",
        },
        start: {
            name: "Start",
            type: "datetime",
        },
        stop: {
            name: "Stop",
            type: "datetime",
        },
        progress: {
            name: "Progress",
            type: "object",
            defaultValue: {},
            userEditable: false,
        },
        productVersion: {
            name: "Version",
            type: "string",
        },
        productStage: {
            name: "Stage",
            type: "string",
        },
        author: {
            name: "Started by",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
        jobTasks: {
            type: 'oneToMany',
            hasPaging: false,
            defaultValue: {},
            to: types['jobTasks'],
        },
        logger: {
            type: 'oneToMany',
            to: types['loggers'],
            foreignKeys: [
                {
                    from: "id",
                    to: "job_id"
                },
                {
                    from: "instance_id",
                    to: "instance_id"
                },
            ]
        },
    }; }
});
